import React from 'react'
import TrainerUserLogin from '../feature/Login/TrainerUserLogin'

const TrainerUserLoginPage = () => {
  return (
     <TrainerUserLogin/>
  )
}

export default TrainerUserLoginPage

